import { FormControl, FormControlLabel, FormLabel, IconButton, InputAdornment, Radio, RadioGroup, TextField, Tooltip } from "@mui/material";
import { useState } from "react";
import { DynamicFormControl, SelectOption } from "../../../";
import { getLocalizedStringMethods, localizeText, useTranslateDetection } from "../../helpers/translate-helper";
import LocalizedStrings, { LocalizedStringsMethods } from "react-localization";
import './radio-button-control.css';

function RadioButtonControl(props: DynamicFormControl) {
    let defaultFormValues: boolean[] = [];
    if (props.selectPropertyOptions != null) {
        defaultFormValues = props.selectPropertyOptions.map(x => false);
    } else if (props.selectOptions != null) {
        defaultFormValues = props.selectOptions.map(x => false);
    }

    const [value, setValue] = useState<string | string[] | null>(null);
    const [formValues, setFormValues] = useState<boolean[]>(defaultFormValues);
    const { currentLanguage } = useTranslateDetection();
    
    let strings: LocalizedStringsMethods | null = getLocalizedStringMethods(props, currentLanguage);
    

    const handleChange = (event: any, item: string, index: number) => {
        if (props.setState) {
            props.setState(item);
        }
        setValue(item);


        const updatedCheckedState = formValues.map((item, i) =>
            index === i ? !item : item
        );

        setFormValues(updatedCheckedState);
    };

    if (props.updater != null) {
        props.updater.setValue = value => {
            setValue(value === '' ? null : value);

            if (value === '') {
                const updatedCheckedState = formValues.map(x => false);

                setFormValues(updatedCheckedState);
            }
        };
    }

    return (

        <FormControl disabled={props.disabled}>
            <FormLabel id={props.id + "-label"}>{props.label}{props.required ? ' *' : ''}</FormLabel>
            <RadioGroup
                row={props.rows != null}
                aria-labelledby={props.id + "-label"}
                name={props.label}
                defaultValue={props.value}
            >
                {props.selectOptions?.map((x, i) => {
                    const option = x as SelectOption;
                    let optionLabel = option?.label ?? x;
                    const optionValue = option?.value ?? x;

                    let hasLocalization = false;

                    if (strings != null) {
                        const localization = localizeText(strings, optionLabel);
                        hasLocalization = localization.hasMatch;
                        optionLabel = localization.localization;
                    }

                    return (
                        <FormControlLabel className={props.skipTranslation || hasLocalization ? "notranslate" : undefined} key={optionValue} value={optionValue} control={<Radio required={props.required} onChange={(e) => handleChange(e, optionValue, i)} />} label={optionLabel} />
                    )
                })}

                {props.selectPropertyOptions?.map((x, i) => {
                    const option = x.label as SelectOption;
                    let optionLabel = option?.label ?? option;
                    const optionValue = option?.value ?? option;

                    let hasLocalization = false;

                    if (strings != null) {
                        const localization = localizeText(strings, optionLabel);
                        hasLocalization = localization.hasMatch;
                        optionLabel = localization.localization;
                    }

                    return (
                        <FormControlLabel className={props.skipTranslation || hasLocalization ? "notranslate" : undefined} key={optionValue} value={optionValue} control={<Radio required={props.required} onChange={(e) => handleChange(e, optionLabel, i)} />} label={optionLabel} />
                    )
                })}

            </RadioGroup>
        </FormControl>
    );
}


export default RadioButtonControl;